export const defaultModalsId = {
  successModal: 'SuccessModal',
  registrationSuccessModal: 'RegistrationSuccessModal',
  traineeSuccessModal: 'TraineeSuccessModal',
  errorModal: 'ErrorModal',
  addEventCalendarModal: 'AddEventCalendarModal',
};
